import { css } from '@emotion/react'
import { Heading, HFlow, Tag, Text, VFlow } from 'bold-ui'
import { IconDateRange } from 'components/IconDateRange'
import { usePrincipiosAtivosAlergiasQuery } from 'graphql/hooks.generated'
import { ReceitaMedicamento, TipoReceitaEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'
import { getTextoDataFimTratamento } from 'view/atendimentos/detail/components/modals/medicamentos/MedicamentosAccordionItemHeader'
import { PrescricaoRenovadaLabel } from 'view/atendimentos/detail/components/modals/medicamentos/PrescricaoRenovadaLabel'

import { TipoReceitaTag } from '../../../components/TipoReceitaTag'
import { AlergiaPrincipioAtivoAlert } from './AlergiaPrincipioAtivoAlert'

interface MedicamentosEmUsoSectionProps {
  prontuarioId: ID
  receita: ReceitaMedicamento
}

export function MedicamentoEmUsoSection(props: Readonly<MedicamentosEmUsoSectionProps>) {
  const { prontuarioId, receita } = props

  const {
    data: { principiosAtivosAlergias },
  } = usePrincipiosAtivosAlergiasQuery({
    variables: { prontuarioId: prontuarioId },
  })

  const isAlergico = useMemo(() => {
    const principioId = receita?.medicamento?.medicamentoCatmat?.principioAtivo?.id

    return principiosAtivosAlergias?.some((principio) => principio.id === principioId)
  }, [receita, principiosAtivosAlergias])

  const dataInicio = formatDate(receita.dtInicioTratamento)
  const dataFim = getTextoDataFimTratamento(receita)

  const isRenovado = !isUndefinedOrNull(receita.receitaUsoContinuoGrupo?.id)

  return (
    <HFlow
      justifyContent='space-between'
      alignItems='center'
      style={css`
        padding: 0.5rem;
      `}
    >
      <VFlow vSpacing={0.25}>
        <HFlow hSpacing={0.5}>
          <Heading level={4}>{`${receita.medicamento.principioAtivo} ${
            receita.medicamento.concentracao ?? ''
          }`}</Heading>
          {receita.usoContinuo && <Tag>Uso contínuo</Tag>}
          {receita.tipoReceita !== TipoReceitaEnum.COMUM && <TipoReceitaTag tipoReceita={receita.tipoReceita} />}
        </HFlow>
        <Text>{`${receita.posologia} (${receita.aplicacaoMedicamento.nome})`}</Text>
        {isAlergico && <AlergiaPrincipioAtivoAlert />}
        {isRenovado && <PrescricaoRenovadaLabel atendProf={receita.atendProf} />}
      </VFlow>
      <IconDateRange startDate={dataInicio} endDate={dataFim} />
    </HFlow>
  )
}
